import axios from 'axios';
import { getAuthHeaders } from './authService';

const base = `${(process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '')}/ops/backup-reports`;
const config = () => ({ headers: getAuthHeaders(), timeout: 130000 });

export const backupReportsApi = {
  options: () => axios.get(`${base}/options`, config()),
  query: (filters, page = 1) => axios.get(base, { ...config(), params: { ...filters, page } }),
  generate: (filters) => axios.post(`${base}/generate`, filters, config()),
  policies: (cliente) => axios.post(`${base}/policies`, { cliente }, config()),
  history: (filters) => axios.get(`${base}/history`, { ...config(), params: filters }),
  status: (requestToken) => axios.get(`${base}/status`, {
    ...config(), params: { request_token: requestToken },
  }),
};
